import * as React from 'react';
import classNames from 'classnames';
import { SpacingSize } from '@/types/spacing';
import styles from './VerticalSpacer.module.scss';
import { VerticalSpacerComponentProps } from './register';

interface VerticalSpacerProps extends VerticalSpacerComponentProps<'unset' | SpacingSize['value']> {
	readonly attributes?: React.HTMLAttributes<HTMLDivElement>;
}

/**
 * CMS VerticalSpacer component, used for creating vertical space between elements via the spacing utility.
 */
export const VerticalSpacer: React.FunctionComponent<VerticalSpacerProps> = ({
	desktopSize,
	tabletSize,
	mobileSize,
	attributes,
}) => {
	const { className: builderClassNames, ...restOfAttributes } = attributes || {};

	return (
		<div
			className={classNames(
				styles.wrapper,
				{
					[styles.hasTabletSize]: tabletSize && tabletSize !== 'unset',
					[styles.hasMobileSize]: mobileSize && mobileSize !== 'unset',
				},
				builderClassNames,
			)}
			{...restOfAttributes}
			key={'verticalSpacer'}
			style={
				{
					'--desktopSize': desktopSize,
					'--tabletSize': tabletSize ?? undefined,
					'--mobileSize': mobileSize ?? undefined,
				} as React.CSSProperties
			}
		/>
	);
};
